import { memo, useState, useEffect, useRef } from 'react'
import logo2 from '@/assets/images/logo-color.png'
import SvgIcon from '@/components/SvgIcon/SvgIcon'
import { Modal } from 'antd'
import ScaledText from '@/components/ScaledText/ScaledText'
import UserAgree from '@/components/UserAgree/UserAgree'
import Privacy from '@/components/Privacy/Privacy'
import { useAbortableRequest } from '@/hooks/useAbortableRequest'
import { useUserInfo } from '@/hooks/useUserInfo'
import './LoginModal.less'

const LoginModal = ({ visible, className, onCancel, onOk }: any) => {
  const { fetchUserInfo } = useUserInfo()
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const { sendRequest, abort } = useAbortableRequest()
  const [code, setCode] = useState<string | undefined>()
  const [xieyi, setXieyi] = useState<boolean>(false)
  const [yinsi, setYinsi] = useState<boolean>(false)
  useEffect(() => {
    showqrcode()
    return () => {
      cleartimeout()
      abort()
    }
  }, [])
  const showqrcode = async () => {
    const result: any = await sendRequest({
      method: 'post',
      url: 'showqrcode',
      data: {}
    })
    if (result?.res) {
      setCode(result.res.data.url)
      loop_login(result.res.data.scene_id)
    }
  }
  const loop_login = async (scene_id: number) => {
    const result: any = await sendRequest(
      {
        method: 'post',
        url: 'loop_login',
        data: { scene_id }
      },
      { showTip: false }
    )
    if (result?.res) {
      localStorage.setItem('uniToken', result.res.data.token)
      fetchUserInfo()
      onOk?.()
      handleCancel()
    } else {
      cleartimeout()
      timer.current = setTimeout(() => {
        loop_login(scene_id)
      }, 3000)
    }
  }
  const handleCancel = () => {
    cleartimeout()
    abort()
    onCancel()
  }
  const cleartimeout = () => {
    if (timer.current) clearTimeout(timer.current)
  }
  return (
    <>
      <Modal
        wrapClassName={`${className || ''} small-modal-container`}
        open={visible}
        onCancel={handleCancel}
        title=''
        footer={null}
        centered
        width={320}
        height={460}
      >
        <div className='logo'>
          <img src={logo2} />
        </div>
        <div className='title'>
          <SvgIcon href={'icon-weixin-copy'} />
          <span>微信登录</span>
        </div>
        <img className='code' src={code} />
        <p>请使用微信扫码登录</p>
        <ScaledText className='xieyi' size={10}>
          <i className='icon-duigou1' />
          我已阅读并接受文果平台 &nbsp;<span onClick={() => setXieyi(true)}>用户协议</span>、
          <span onClick={() => setYinsi(true)}>隐私声明</span>
        </ScaledText>
      </Modal>
      <UserAgree open={xieyi} onCancel={() => setXieyi(false)} />
      <Privacy open={yinsi} onCancel={() => setYinsi(false)} />
    </>
  )
}

export default memo(LoginModal)
